import { render, staticRenderFns } from "./PeriodoDataInicioFinal.vue?vue&type=template&id=56208854&"
import script from "./PeriodoDataInicioFinal.vue?vue&type=script&lang=js&"
export * from "./PeriodoDataInicioFinal.vue?vue&type=script&lang=js&"
import style0 from "./PeriodoDataInicioFinal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports